import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './OrRuler.css';
export const OrRuler = (props) => {
    const position = props.position || 'mid';
    return _jsxs("div", { className: 'orRuler orRuler' + position.charAt(0).toUpperCase() + position.slice(1), children: [_jsx("div", { className: "orLine" }), _jsx("div", { className: "orText", children: props.text || 'or' }), _jsx("div", { className: "orLine" })] });
};
